import { render, staticRenderFns } from "./volcList.vue?vue&type=template&id=9176f22a&scoped=true"
import script from "./volcList.vue?vue&type=script&lang=js"
export * from "./volcList.vue?vue&type=script&lang=js"
import style0 from "./volcList.vue?vue&type=style&index=0&id=9176f22a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9176f22a",
  null
  
)

export default component.exports